import React from 'react';

import { AddProductToChargeDetails } from 'lane-shared/domains/billingPayments/types';
import { type SupportedPaymentCurrency } from 'domains-billing-currency';

import { Table } from 'design-system-web';

import { useTableColumnsAddedProducts } from './useTableColumnsAddedProducts';

import styles from '../addProductToChargeStyles.scss';

export function AddedProductsTable({
  listOfProducts,
  currency,
  editProduct,
  removeProduct,
}: {
  listOfProducts: AddProductToChargeDetails[];
  currency: SupportedPaymentCurrency;
  editProduct: Function;
  removeProduct: Function;
}) {
  const chargeColumns = useTableColumnsAddedProducts({
    currency,
    editProduct,
    removeProduct,
  });

  return (
    <div className={styles.addedProductsTable} data-test="AddedProductsTable">
      <Table
        columns={chargeColumns}
        data={listOfProducts}
        disableSorting
        isLoading={false}
      />
    </div>
  );
}
